export default function CheckSSOLogin() {

	return new Promise((resolve, reject) => {
		fetch("api/ConsumerApplication/IsSSOAuthenticated", {
			method: "GET",
			headers: {
				'Content-Type': 'application/json',
			}
		})
			.then(data => data.json())
			.then(json => {
				resolve(json);
			})
			.catch((error) => {
				reject(error);
			});
	});
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/CheckSSOLogin.js